import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import _ from 'lodash';
import { locations, grades } from './raPruefung';
import { 
    getYearPercentageBarChartOptions, 
    getYears, 
    getPercentOfCityEachGrade, 
    getListOfNumbersPerGradeOfAllYearsAllLocations, 
    groupByCityAndYears, 
    getAustria
} from '../utilities/dataTransformer';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from '@mui/material';

class PopChart extends Component {
    constructor(props) {
        super(props);

        var years = this.makeYearList(2010, 2020);

        var cityAndYearGroups = groupByCityAndYears(years);

        var listOfGradeNumbers = getListOfNumbersPerGradeOfAllYearsAllLocations(cityAndYearGroups);

        //var austria = getAustria(listOfGradeNumbers)
      
        //console.log(listOfGradeNumbers);

        /* Graz */
        //var graz = _.slice(listOfGradeNumbers, 0, 2);

        var grazSumme = _.reduce(listOfGradeNumbers[locations.Graz], function (sum, n) {
            return sum + n;
        }, 0);

        var grazPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Graz], grazSumme);


        /* Innsbruck */
        //var innsbruck = _.slice(listOfGradeNumbers, 2, 4);

        var innsbruckSumme = _.reduce(listOfGradeNumbers[locations.Innsbruck], function (sum, n) {
            return sum + n;
        }, 0);

        var innsbruckPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Innsbruck], innsbruckSumme);


        /* Linz */
        //var linz = _.slice(listOfGradeNumbers, 4, 6);

        var linzSumme = _.reduce(listOfGradeNumbers[locations.Linz], function (sum, n) {
            return sum + n;
        }, 0);

        var linzPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Linz], linzSumme);


        /* Wien */
        //var wien = _.slice(listOfGradeNumbers, 6, 8);

        var wienSumme = _.reduce(listOfGradeNumbers[locations.Wien], function (sum, n) {
            return sum + n;
        }, 0);

        var wienPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Wien], wienSumme);

        listOfGradeNumbers["Austria"] = [0, 0, 0, 0];
        
        Object.values(listOfGradeNumbers).forEach((cityArray) => {

            Object.keys(cityArray).forEach((gradeIndex) => {
                listOfGradeNumbers["Austria"][gradeIndex] += cityArray[gradeIndex];
            });

        });

        var austriaSumme = _.reduce(listOfGradeNumbers["Austria"], function (sum, n) {
            return sum + n;
        }, 0);

        var austriaPercent = getPercentOfCityEachGrade(listOfGradeNumbers["Austria"], austriaSumme);

        this.state = {
            selectableYears: getYears(),
            selectedStartYear: "2010",
            selectedEndYear: "2020",
            selectedYears: years,
            shouldUpdate: false,
            gradeIndex: 3,
            options: getYearPercentageBarChartOptions(years),
            
            series: [{
                name: locations.Graz,
                data: grazPercent,
            }, {
                name: locations.Innsbruck,
                data: innsbruckPercent
            }, {
                name: locations.Linz,
                data: linzPercent
            }, {
                name: locations.Wien,
                data: wienPercent
            },
            {
                name: 'Österreich',
                data: austriaPercent
            }
            ],
        }
    }
        
        makeYearList = (startYear, endYear) => {
            var yearArray = [];

            var startYearInt = parseInt(startYear);
            var endYearInt = parseInt(endYear);

            for (var i = startYearInt; i <= endYearInt; i++) {
                yearArray.push(i);
            }

            return yearArray;
        }

        selectedStartYear = (e) => {
            this.setState({
                ...this.state,
                selectedStartYear: e.target.value,
                shouldUpdate: true
            });
        };

        selectedEndYear = (e) => {
            this.setState({
                ...this.state,
                selectedEndYear: e.target.value,
                shouldUpdate: true
            });
        };

        componentDidUpdate(prevState) {
            if (this.state.shouldUpdate) {
                this.setState({
                    ...this.state,
                    shouldUpdate: false,
                });
                var years = this.makeYearList(this.state.selectedStartYear, this.state.selectedEndYear);
                var cityAndYearGroups = groupByCityAndYears(years);


                var listOfGradeNumbers = getListOfNumbersPerGradeOfAllYearsAllLocations(cityAndYearGroups);
                   
        
//var austria = getAustria(listOfGradeNumbers)
      
        //console.log(listOfGradeNumbers);

        /* Graz */
        //var graz = _.slice(listOfGradeNumbers, 0, 2);

        var grazSumme = _.reduce(listOfGradeNumbers[locations.Graz], function (sum, n) {
            return sum + n;
        }, 0);

        var grazPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Graz], grazSumme);


        /* Innsbruck */
        //var innsbruck = _.slice(listOfGradeNumbers, 2, 4);

        var innsbruckSumme = _.reduce(listOfGradeNumbers[locations.Innsbruck], function (sum, n) {
            return sum + n;
        }, 0);

        var innsbruckPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Innsbruck], innsbruckSumme);


        /* Linz */
        //var linz = _.slice(listOfGradeNumbers, 4, 6);

        var linzSumme = _.reduce(listOfGradeNumbers[locations.Linz], function (sum, n) {
            return sum + n;
        }, 0);

        var linzPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Linz], linzSumme);


        /* Wien */
        //var wien = _.slice(listOfGradeNumbers, 6, 8);

        var wienSumme = _.reduce(listOfGradeNumbers[locations.Wien], function (sum, n) {
            return sum + n;
        }, 0);

        var wienPercent = getPercentOfCityEachGrade(listOfGradeNumbers[locations.Wien], wienSumme);

        listOfGradeNumbers["Austria"] = [0, 0, 0, 0];
        
        Object.values(listOfGradeNumbers).forEach((cityArray) => {

            Object.keys(cityArray).forEach((gradeIndex) => {
                listOfGradeNumbers["Austria"][gradeIndex] += cityArray[gradeIndex];
            });

        });

        var austriaSumme = _.reduce(listOfGradeNumbers["Austria"], function (sum, n) {
            return sum + n;
        }, 0);

        var austriaPercent = getPercentOfCityEachGrade(listOfGradeNumbers["Austria"], austriaSumme);
            
            this.setState({
                options: getYearPercentageBarChartOptions(years),
                series: [{
                    name: locations.Graz,
                data: grazPercent,
            }, {
                name: locations.Innsbruck,
                data: innsbruckPercent
            }, {
                name: locations.Linz,
                data: linzPercent
            }, {
                name: locations.Wien,
                data: wienPercent
            },
                {
                    name: 'Österreich',
                    data: austriaPercent
                }
                ],
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="chart-container">
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type='bar'
                    height="100%"
                    width="100%"
                />
                </div>
                <Grid container spacing={5}>
                    <Grid item md={4}>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="yearPicker">
                                Start Jahr
                            </InputLabel>
                            <Select
                                label="Start Jahr"
                                name="yearPicker"
                                id="yearPicker"
                                value={this.state.selectedStartYear}
                                onChange={this.selectedStartYear.bind(this)}
                            >
                               {this.state.selectableYears
                                .filter((year) => year <= this.state.selectedEndYear)
                                .map((year) => (
                                    <MenuItem key={year}
                                        value={year}>
                                        {year}
                                    </MenuItem>
                                ),
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={4}>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="yearPicker">
                                End Jahr
                            </InputLabel>
                            <Select
                                label="End Jahr"
                                name="yearPicker"
                                id="yearPicker"
                                value={this.state.selectedEndYear}
                                onChange={this.selectedEndYear.bind(this)}
                            >
                                 {this.state.selectableYears
                                .filter((year) => year >= this.state.selectedStartYear)
                                .map((year) => (
                                    <MenuItem key={year}
                                        value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default PopChart;